<div class="space-y-6">
  <div *ngIf="reconciliation">
    <h2 class="text-primary poppins-medium font-bold mb-4 text-lg md:text-xl">
      GST Reconciliation of Books with GSTR - 2B
    </h2>
    <!-- Scrollable Table Container -->
    <div class="overflow-x-auto">
      <table class="mt-4 table-auto border-collapse border shadow-md border-gray-400 w-full text-center">
        <thead class="bg-primary text-white">
          <tr>
            <th class="border border-gray-400 p-2 md:p-3">Particulars</th>
            <th class="border border-gray-400 p-2 md:p-3">IGST</th>
            <th class="border border-gray-400 p-2 md:p-3">CGST</th>
            <th class="border border-gray-400 p-2 md:p-3">SGST</th>
            <th class="border border-gray-400 p-2 md:p-3">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border border-gray-400 p-2 md:p-3">Total Book Entries</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.total_book_entries.igst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.total_book_entries.cgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.total_book_entries.sgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.total_book_entries.total_gst }}</td>
          </tr>
          <tr class="bg-gray-200">
            <td class="border border-gray-400 p-2 md:p-3">Less: Unmatched Book Entries</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.unmatched_book_entries.igst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.unmatched_book_entries.cgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.unmatched_book_entries.sgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.unmatched_book_entries.total_gst }}</td>
          </tr>
          <tr class="bg-primary text-white">
            <td class="border border-gray-400 p-2 md:p-3">Input Tax Credit to be Availed as per GSTR-3B</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.credit_availed_gstr_3b.igst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.credit_availed_gstr_3b.cgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.credit_availed_gstr_3b.sgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.credit_availed_gstr_3b.total_gst }}</td>
          </tr>
          <tr>
            <td class="border border-gray-400 p-2 md:p-3">Add: Unmatched GSTR-2B Entries</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.unmatched_gstr_2b_entries.igst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.unmatched_gstr_2b_entries.cgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.unmatched_gstr_2b_entries.sgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.unmatched_gstr_2b_entries.total_gst }}</td>
          </tr>
          <tr class="bg-gray-200" *ngIf="reconciliation?.calculated_total_gstr_2b_entries">
            <td class="border border-gray-400 p-2 md:p-3">Calculated Total GSTR-2B Entries</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.calculated_total_gstr_2b_entries.igst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.calculated_total_gstr_2b_entries.cgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.calculated_total_gstr_2b_entries.sgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.calculated_total_gstr_2b_entries.total_gst }}</td>
          </tr>
          <tr *ngIf="reconciliation?.actual_total_gstr_2b_entries">
            <td class="border border-gray-400 p-2 md:p-3">Actual Total GSTR-2B Entries</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.actual_total_gstr_2b_entries.igst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.actual_total_gstr_2b_entries.cgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.actual_total_gstr_2b_entries.sgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.actual_total_gstr_2b_entries.total_gst }}</td>
          </tr>
          <tr class="bg-red-200" *ngIf="reconciliation?.difference_tolerance">
            <td class="border border-gray-400 p-2 md:p-3">Difference due to Tolerance</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.difference_tolerance.igst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.difference_tolerance.cgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.difference_tolerance.sgst }}</td>
            <td class="border border-gray-400 p-2 md:p-3">{{ reconciliation.difference_tolerance.total_gst }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
<div class="space-y-6"  *ngIf="suppliers_report">
  <h2 class="poppins-medium text-gray-500">Top 10 suppliers not filed their GSTR - 1 Return</h2>

  <div class="overflow-x-auto">
    <table  class="mt-4 table-auto border-collapse border shadow-md border-gray-400 w-full text-center">
      <thead class="bg-primary text-white">
        <tr>
          <th class="border border-gray-400 p-2 md:p-3">GSTN</th>
          <th class="border border-gray-400 p-2 md:p-3">IGST</th>
          <th class="border border-gray-400 p-2 md:p-3">CGST</th>
          <th class="border border-gray-400 p-2 md:p-3">SGST</th>
          <th class="border border-gray-400 p-2 md:p-3">Total Tax</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let index of suppliers_report?.GSTN; let i = index" [ngClass]="{'bg-white': i % 2 === 0, 'bg-gray-200': i % 2 !== 0}">
          <td class="border border-gray-400 p-2 md:p-3">{{ suppliers_report.GSTN[i] }}</td>
          <td class="border border-gray-400 p-2 md:p-3">{{ suppliers_report.IGST[i] | indianNumber }}</td>
          <td class="border border-gray-400 p-2 md:p-3">{{ suppliers_report.CGST[i] | indianNumber }}</td>
          <td class="border border-gray-400 p-2 md:p-3">{{ suppliers_report.SGST[i] | indianNumber }}</td>
          <td class="border border-gray-400 p-2 md:p-3">{{ suppliers_report.Total_Tax[i] | indianNumber }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>
